import React from 'react';
import { CheckCircle } from 'lucide-react';

export default function ScoreItem({ label, checked }) {
  return (
    <li className="flex items-center gap-3">
      <div className={`w-4 h-4 rounded border flex items-center justify-center ${checked ? 'bg-green-500 border-green-500 text-white' : 'border-gray-700 text-transparent'}`}>
        <CheckCircle size={12} />
      </div>
      <span className={`text-xs ${checked ? 'text-gray-300' : 'text-gray-500'}`}>{label}</span>
    </li>
  );
}
